import React from 'react'
import VerificationCode from '../../../Components/Molecules/ForgotPassword/VerificationCode/VerificationCode'

function VerificationCodeTemplate() {
  return (
    <VerificationCode />
  )
}

export default VerificationCodeTemplate